// UI-tour "have I seen it" wire layer — GET/PUT /v1/me/ui-tour.
//
// Self-directed, no permission cell: the exact posture /v1/me/locale takes
// (requireAuth only; the write pins to the caller's resolved employee row).

import { unwrapEnvelope } from "@/api/errors";
import { platformGraph } from "@/api/platform-graph";

export interface UiTourState {
  /** Highest TOUR_VERSION the caller has acknowledged; null = never shown. */
  readonly seen_version: number | null;
}

export async function fetchUiTourState(): Promise<UiTourState> {
  const data = await unwrapEnvelope(platformGraph.GET("/v1/me/ui-tour"));
  return { seen_version: data.seen_version };
}

/**
 * Persist the acknowledged version. The endpoint answers 204 — deliberately
 * NOT routed through `unwrapEnvelope`, which treats an empty body as a
 * synthetic dependency error (it exists to unwrap envelopes, and a 204 has
 * none). A non-2xx still throws so the caller's mutation surfaces it.
 */
export async function saveUiTourSeenVersion(seenVersion: number): Promise<void> {
  const result = await platformGraph.PUT("/v1/me/ui-tour", {
    body: { seen_version: seenVersion },
  });
  const status = result.response?.status ?? 0;
  if (status < 200 || status >= 300) {
    throw new Error(`PUT /v1/me/ui-tour failed with HTTP ${String(status)}`);
  }
}
